import { render } from "./SidebarItem.vue?vue&type=template&id=240a6f91&scoped=true"
import script from "./SidebarItem.vue?vue&type=script&lang=js"
export * from "./SidebarItem.vue?vue&type=script&lang=js"

import "./SidebarItem.vue?vue&type=style&index=0&id=240a6f91&lang=scss&scoped=true"

import exportComponent from "/Users/dongyucheng/小飞蛾/得乐线上化/dele-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-240a6f91"]])

export default __exports__